import { render, staticRenderFns } from "./DeleteWidgetModal.vue?vue&type=template&id=1e750614"
import script from "./DeleteWidgetModal.vue?vue&type=script&lang=js"
export * from "./DeleteWidgetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e750614')) {
      api.createRecord('1e750614', component.options)
    } else {
      api.reload('1e750614', component.options)
    }
    module.hot.accept("./DeleteWidgetModal.vue?vue&type=template&id=1e750614", function () {
      api.rerender('1e750614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/DeleteWidgetModal.vue"
export default component.exports